export const toEuro = (num: number) => {
  return num.toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: 'currency',
    currency: 'EUR',
  });
};

export const toEuroWholeNumber = (num: number) => {
  return num.toLocaleString('de-DE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    style: 'currency',
    currency: 'EUR',
  });
};

export const toWholeNumber = (num: number) => {
  return num.toLocaleString('de-DE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

export const toPercent = (num: number, minimumFractionDigits = 2, maximumFractionDigits = 2) => {
  return num
    .toLocaleString('de-DE', {
      minimumFractionDigits: minimumFractionDigits,
      maximumFractionDigits: maximumFractionDigits,
      style: 'percent',
    })
    .replace(' ', '');
};

export const toPercentWholeNumber = (num: number) => {
  return num
    .toLocaleString('de-DE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      style: 'percent',
    })
    .replace(' ', '');
};
